module.exports = __webpack_public_path__ + "img/white_paper5.e8efc510.png";